import script from "./DashboardCellOkrCount.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCellOkrCount.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCellOkrCount.vue?vue&type=style&index=0&id=0dcd3858&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcd3858"]])

export default __exports__